import { c as _c } from "react/compiler-runtime";
import { type DependencyList, useEffect } from 'react';
export const useDebounceEffect = (fn, waitTime, deps) => {
  const $ = _c(5);
  let t0;
  if ($[0] !== fn || $[1] !== waitTime) {
    t0 = () => {
      const timer = setTimeout(() => {
        fn();
      }, waitTime);
      return () => clearTimeout(timer);
    };
    $[0] = fn;
    $[1] = waitTime;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== deps) {
    t1 = deps ?? [];
    $[3] = deps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
};